export default __webpack_public_path__ + "media/images/metal_detect/foxes_detect_7-7b562dc55220d4bb592afc64d6517802.svg";